// extracted by mini-css-extract-plugin
export default {"btn":"PlusButton_btn__-9OHh"};